import ReceptionistDashboard from "../pages/ReceptionistDashboard";

export const ENDPOINTS = {
    // auth
    login: "admin",
    resetPassword: "auth/reset-password",
    forgotPassword: "auth/forgot-password",

    //user management
    getUser: "users",
    getUserById: "users",
    getUserByRole: "users/role",
    saveUser: "auth/register",
    updateUser: "auth/edit-user",
    deleteUser: "auth/delete-user",

    // Role
    getRolesApi : "auth/roles",

    // plan Management
    getPlan: "plan/list",
    getPlanBy: "plan", 
    getPlanHistoryByUser: "plan/history/user",
    getPlanHistory: "plan/history/users",
    savePlan: "plan/create",
    updatePlan: "plan/edit",
    deletePlan: "plan/delete",
    assignPlan: "plan/assign",

    //payment
    getPayment:"payment/list",
    savePayment:"payment/create",

    // enquiries
    getEnquiries : "enquiry/list",
    getEnquiryById : "enquiry",
    saveEnquiry : "enquiry/create", 
    convertEnquiry : "enquiry/status", 

    // followup
    getFollowups : "enquiry/followup/list",
    getFollowupById : "enquiry/followup/list",
    saveFollowup : "enquiry/followup/create", 

    // device config
    getDevice : "device/list",
    getDeviceById : "device", //followed by id
    createDevice : "device/create",
    updateDevice : "device/edit", //followed by id

    // sessions
    getSessionsByIdApi : "session", //followed by id 
    getSessionByUser : "session/by_user",
    getAllSessionsApi : "session/list",
    newBookingApi : "session/book",
    cancelBookingApi : "session/cancel", //followed by id

    // Settings
    getAllSettingsApi : "settings/list", 
    getSettingsByApi : "settings",  //followed by key
    createSettingsApi : "settings/create-update",

    // Attendance
    getManualEntry : "attendance/all",
    addManualEntry : "attendance/manual",
    getAttendanceBy : "attendance/by_member_id",

    // Notification
    notificationApi : "notification/queue",  
    getNotificationApi : "notification/history",  

    //dashboard
    ReceptionistDashboardApi:"dashboard/receptionist",
    adminDashboardApi:"dashboard/all",

    //mail
    sendPdfApi : 'mail/send-pdf'
};
